import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastTextField } from 'src/components/mui-overrides/Textfield';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { POST_WITH_ID } from '@brickwise/asset-validation/dist/asset/assetData';
import { DefaultFastTextAreaField } from 'src/components/mui-overrides/Textarea';
import { UploadDropzone } from 'src/components/ui/UploadDropzone';
import { ImageViewList } from 'src/components/ui/ImageViewList';
import { PropertyHighlightTextField } from '../atomic-components/PropertyHighlightTextField';
import { PropertyDetailsTextField } from '../atomic-components/PropertyDetailsTextField';

interface Props {
  disabled: boolean;
}

export const PowerplantDetails: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const formik = useFormikContext<POST_WITH_ID>();

  const currentImages = formik.values.images?.powerplant || [];

  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.main.powerplantdetails.title')}>
      <PropertyHighlightTextField />

      <PropertyDetailsTextField />
      <DefaultFastTextField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.powerplantpicture.title.label')}
        fieldName="descriptions.powerplantPictureTitle"
      />

      <DefaultFastTextField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.moduleType.label')}
        fieldName="descriptions.moduleType"
      />

      <DefaultFastTextField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.nominalPowerPerModule.label')}
        fieldName="descriptions.nominalPowerPerModule"
      />

      <DefaultFastTextAreaField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.powerplantpicture.details.label')}
        fieldName="descriptions.powerplantPictureDetails"
      />
      <div>
        <label>{t('dashboard.assets.addedit.main.powerplantpicture.upload.label')}</label>
        <UploadDropzone
          disabled={disabled}
          imageUploaded={(url: string, name: string) => {
            formik.setFieldValue('images.powerplant', [
              ...currentImages,
              {
                src: url,
                name,
              },
            ]);
          }}
        />
        <ImageViewList disabled={disabled} data={currentImages} setData={(data) => formik.setFieldValue('images.powerplant', data)} />
      </div>
    </LaunchpadCard>
  );
};
